import React from 'react';
import IconBase from './Icon-base';
export default class Highlight extends React.Component {
    render() {
        return (
            <IconBase width="34" height="27" viewBox="0 0 34 27" {...this.props}>
                <g id="Canvas" transform="translate(359 232)">
                    <g id="Group 2">
                        <g id="T">
                            <use
                                xlinkHref="#path0_fill_high"
                                transform="translate(-357 -233)"
                                fill="#4F5056"
                            />
                        </g>
                        <g id="Rectangle 2">
                            <use
                                xlinkHref="#path1_fill_high"
                                transform="translate(-359 -212)"
                                fill="#4F5056"
                            />
                        </g>
                        <g id="Marker Selector">
                            <g id="Shape">
                                <use
                                    xlinkHref="#path2_fill_high"
                                    transform="matrix(0.866025 0.5 0.5 -0.866025 -344.833 -215.791)"
                                    fill="#4F5056"
                                />
                            </g>
                            <g id="Shape">
                                <use
                                    xlinkHref="#path3_fill_high"
                                    transform="matrix(0.866025 0.5 0.5 -0.866025 -344.588 -210.059)"
                                    fill="#4F5056"
                                />
                            </g>
                        </g>
                    </g>
                </g>
                <defs>
                    <path
                        id="path0_fill_high"
                        d="M 3.474 17L 8.478 17L 8.478 15.596L 6.876 15.596L 6.876 5.768L 9.864 5.768L 9.864 7.748L 11.43 7.748L 11.43 4.292L 0.522 4.292L 0.522 7.748L 2.088 7.748L 2.088 5.768L 5.076 5.768L 5.076 15.596L 3.474 15.596L 3.474 17Z"
                    />
                    <path
                        id="path1_fill_high"
                        d="M 0 1C 0 0.447715 0.447715 0 1 0L 13.8005 0C 14.1005 0 14.3847 0.134675 14.5746 0.36688L 18.6642 5.36688C 19.1983 6.01984 18.7337 7 17.8902 7L 1 7C 0.447715 7 0 6.55228 0 6L 0 1Z"
                    />
                    <path
                        id="path2_fill_high"
                        fillRule="evenodd"
                        d="M 0.577268 18.0877L 0.577268 9.42872C 0.577268 7.96169 1.43124 6.60106 2.7528 5.96203L 3.07877 5.80443L 3.07877 5.44229L 3.07877 0.769691C 3.07877 0.663474 3.16516 0.577268 3.27119 0.577268L 8.27418 0.577268C 8.38021 0.577268 8.4666 0.663474 8.4666 0.769691L 8.4666 5.44229L 8.4666 5.80443L 8.79257 5.96203C 10.1141 6.60087 10.9681 7.96169 10.9681 9.42872L 10.9681 18.0877L 11.5454 18.0877L 11.5454 9.42872C 11.5454 7.67421 10.5242 6.15811 9.04387 5.44229L 9.04387 0.769691C 9.04387 0.344629 8.69924 0 8.27418 0L 3.27119 0C 2.84613 0 2.5015 0.344629 2.5015 0.769691L 2.5015 5.44229C 1.02119 6.15811 0 7.67421 0 9.42872L 0 18.0877L 0.577268 18.0877L 0.577268 18.0877Z"
                    />
                    <path
                        id="path3_fill_high"
                        fillRule="evenodd"
                        d="M 0.192615 4.84139L 5.19561 4.84139C 5.26257 4.84139 5.32626 4.85275 5.38803 4.86872L 5.38803 0.57788C 5.38803 0.170906 4.97836 -0.108107 4.59967 0.0404431L 0.488369 1.65564C 0.19377 1.77129 0 2.05549 0 2.37203L 0 4.86891C 0.0619601 4.85275 0.125652 4.84139 0.192615 4.84139Z"
                    />
                </defs>
            </IconBase>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/src/SVGIcons/Highlight.js